import React from "react";
import { Box, Button, Container } from "@mui/material";

const ToggleTab = ({ tabs }) => {
  const currentPath = window.location.pathname;

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fff",
        pt: { xs: 0, sm: 2 },
        pb: 2,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-start" },
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              borderRadius: "9999px",
              border: "1px solid #D1D5DB",
              backgroundColor: "#E5E7EB",
              overflow: "hidden",
              fontSize: "0.75rem",
              fontWeight: 600,
            }}
          >
            {tabs.map((tab, idx) => {
              const isActive = tab.isActive
                ? tab.isActive(currentPath)
                : currentPath.includes(tab.href);

              const gradient =
                idx === 0
                  ? "linear-gradient(to right, #c084fc, #6366f1)"
                  : "linear-gradient(to right, #2563eb, #7dd3fc)";

              return (
                <Button
                  key={tab.href}
                  onClick={() => (window.location.href = tab.href)}
                  sx={{
                    px: { xs: 4, sm: isActive ? 8 : 4 },
                    py: { xs: 1, sm: isActive ? 1.5 : 1 },
                    borderRadius: "9999px",
                    color: isActive ? "#fff" : "#6B7280",
                    fontWeight: "bold",
                    background: isActive ? gradient : "#E5E7EB",
                    transition: "all 0.3s",
                    "&:hover": {
                      opacity: 0.9,
                      background: isActive ? gradient : "#E5E7EB",
                    },
                  }}
                >
                  {tab.label}
                </Button>
              );
            })}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ToggleTab;
